import isEmpty from 'lodash/isEmpty';
import { CheckoutState } from '../../state';
import { getPromoCodeInformation } from '../../utils/promoCodes';
import { getTicketsById } from './pureSelectors';

export const getHasTicketsWithPromoCodeApplied = (state: CheckoutState) =>
    !isEmpty(getPromoCodeInformation(Object.values(getTicketsById(state))));
